import { gql } from '@apollo/client';

const PRACTITIONER_INFORMATION = gql`
  fragment PractitionerInformation on PractitionerType {
    id
    prenuvoId

    salutation
    firstName
    lastName
    profession
    title
    deactivated
    verified

    contact {
      address
      address2
      country

      state
      city
      postalCode

      phoneNumber
      faxNumber
      emailAddress

      deactivated
      verified
    }

    locations {
      edges {
        node {
          id
          locationName

          practice {
            practiceName
          }

          contact {
            address
            address2
            city
            state
            postalCode
            country

            phoneNumber
            faxNumber
            emailAddress

            deactivated
            verified
          }

          practitionerContact {
            phoneNumber
            faxNumber
            emailAddress

            deactivated
            verified
          }
        }
      }
    }
  }
`;

const PRACTITIONERS_DETAILS = gql`
  ${PRACTITIONER_INFORMATION}
  query PractitionersDetails($id: ID!) {
    practitioner(id: $id) {
      ...PractitionerInformation
    }
  }
`;

const PRACTITIONER_LIST = gql`
  ${PRACTITIONER_INFORMATION}
  query PractitionerList {
    practitioners(limit: 100000) {
      totalCount
      edges {
        node {
          ...PractitionerInformation
        }
      }
    }
  }
`;

const PRACTITIONER_LIST_SELECT_INFO = gql`
  query PractitionerListSelectInfo($search: String!) {
    practitioners(limit: 100000, search: $search) {
      totalCount
      edges {
        node {
          id
          firstName
          lastName
          prenuvoId
          locations {
            edges {
              node {
                id
                locationName
                practice {
                  practiceName
                }
              }
            }
          }
        }
      }
    }
  }
`;

const PRACTITIONER_BY_PRENUVO_ID = gql`
  query PractitionerDetailsByPrenuvoId($id: String) {
    practitioner(prenuvoId: $id) {
      firstName
      lastName

      id
      locations {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

const PRACTITIONERS_BY_PRENUVO_IDS = gql`
  query practitionersByIds($practitionersList: [String]!) {
    practitionersByIds(practitionersList: $practitionersList) {
      edges {
        node {
          id
          firstName
          lastName
          prenuvoId

          locations {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const practitionerQueries = {
  PRACTITIONER_BY_PRENUVO_ID,
  PRACTITIONER_LIST,
  PRACTITIONER_LIST_SELECT_INFO,
  PRACTITIONERS_BY_PRENUVO_IDS,
  PRACTITIONERS_DETAILS,
};
